import { render, staticRenderFns } from "./DeedOrderStatus.vue?vue&type=template&id=84dcb498&"
import script from "./DeedOrderStatus.vue?vue&type=script&lang=js&"
export * from "./DeedOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports